import { FETCH_TRADING_CARDS_META, FETCHING_TRADING_CARDS_META, EDIT_TRADING_CARDS_META } from "../actionTypes";

export const fetchingTradingCardMeta = payload => ({
    type: FETCHING_TRADING_CARDS_META,
    payload
});

export const fetchTradingCardsMeta = payload => ({
    type: FETCH_TRADING_CARDS_META,
    payload
});

export const editTradingCardsMeta = payload => ({
    type: EDIT_TRADING_CARDS_META,
    payload
});